module.exports = __webpack_public_path__ + "static/media/13.3e042a93.JPG";